// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V37BBOI0zp3_C_ {
  margin-top: var(--ds-space-500, 40px);
}
.H9ydvpYUGJzJfP {
  height: 20px;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-150, 12px);
  padding: var(--ds-space-100, 8px);
  border-radius: 8px;
  background-color: var(--ds-surface, #ffffff);
  cursor: progress;
  animation-name: XsFlMInNpIvVXs;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes XsFlMInNpIvVXs {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .H9ydvpYUGJzJfP {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonWrapper": `V37BBOI0zp3_C_`,
	"skeletonPopoverOption": `H9ydvpYUGJzJfP`,
	"shimmer": `XsFlMInNpIvVXs`
};
export default ___CSS_LOADER_EXPORT___;
